export enum CheckBoxId {
  TRADEIN_CHECKBOX = 'root_tradeIn_tradeInCheckbox',
  MARKETING_OPTIONS_CHECKBOXES = 'root_marketingCommercialOptins',
}

export enum AutocompleteInputId {
  TRADEIN_BRAND = 'root_tradeIn_makeAutocomplete',
}

export enum TextWidgetId {
  TRADEIN_MODEL = 'root_tradeIn_model',
  TRADEIN_YEAR = 'root_tradeIn_year',
  TRADEIN_MILEAGE = 'root_tradeIn_mileage',
  TRADEIN_REGISTRATION_NUMBER = 'root_tradeIn_registrationNumber',
}
